import React, {useEffect, useState} from 'react';
import ActivityCompleted from "../ActivityCompleted/ActivityCompleted";
import BreakButtons from "../BreakButtons/BreakButtons";
import ExerciseDetail from "../ExerciseDetail/ExerciseDetail";
import PersonInfo from "../PersonInfo/PersonInfo";
import {addToDb, getStoredData} from "../utilities/fakedb";

const Info = (props) => {
    const {exerciseTime} = props;

    const [breakTime, setBreakTime] = useState(0);
    const breakTimeHandler = (newTime) => {
        setBreakTime(newTime);
        addToDb(newTime);
    };

    useEffect(() => {
        const storedData = getStoredData();
        setBreakTime(storedData);
    }, []);


    return (
        <div className="">
            <PersonInfo></PersonInfo>
            <BreakButtons breakTimeHandler={breakTimeHandler}></BreakButtons>
            <ExerciseDetail breakTime={breakTime} exerciseTime={exerciseTime} ></ExerciseDetail>
            <ActivityCompleted></ActivityCompleted>
        </div>
    );
};

export default Info;